<template>
  <router-view />
</template>

<script>
export default {
  name: 'SchemesEditUserRouter',
};
</script>
